import { TAssetEditorProp } from '../../assetEditorProps'
import {
    AMAMeshType,
    isCustomShapes,
    isMeshAMA,
    isSpecificObject,
    isStandardMaterial,
    utilsEditor
} from '@amaspace-editor/editor-3d'
import { isLight } from '../../../../../utils'
import * as THREE from 'three'

const currentMaterialMesh = (editor3D: ReturnType<typeof utilsEditor>): TAssetEditorProp[] => {
    if (!editor3D.activeMesh) return [] as TAssetEditorProp[]

    if (isMeshAMA(editor3D.activeMesh)) {
        if (isLight(editor3D.activeMesh.children[0])) return [] as TAssetEditorProp[]
        if (editor3D.activeMesh.children[0] instanceof THREE.PerspectiveCamera) return [] as TAssetEditorProp[]

        const current = editor3D.getCurrentConfigObj(editor3D.activeMesh)

        if (!isCustomShapes(current) && !isSpecificObject(current, 'Mesh')) return []
        if (current && current.material) {
            if (!isStandardMaterial(editor3D.activeMesh.material)) return []
            const material = editor3D.activeMesh.material

            return [{ type: 'attach', label: 'Material', value: material.userData, key: 'map' }]
        } else {
            let value = null
            if (isStandardMaterial(editor3D.activeMesh.material)) value = editor3D.activeMesh.material.userData
            const material = editor3D.activeMesh.material

            return [
                { type: 'attach', label: 'Material', value: value, key: 'map' }
                // { type: 'range', label: 'Metalness', value: material.metalness, key: 'metalness_mat', misc: { max: 1 } },
                // { type: 'range', label: 'Roughness', value: material.roughness, key: 'roughness_mat', misc: { max: 1 } },
                // { type: 'range', label: 'Opacity', value: material.opacity, key: 'opacity_mat', misc: { max: 1 } },
                // { type: 'switch', label: 'Wireframe', value: material.wireframe, key: 'wireframe_mat', },
                // { type: 'color', label: 'Color', value: material.color, key: 'color_mat', },
                // {
                //   type: 'list',
                //   label: 'Side',
                //   value: objectUtils({ obj: MATERIAL_SIDES, value: material.side }).key,
                //   key: 'side',
                //   misc: {
                //     list: [
                //       { label: 'front', value: THREE.FrontSide, key: 'front_side' },
                //       { label: 'back', value: THREE.BackSide, key: 'back_side' },
                //       { label: 'double', value: THREE.DoubleSide, key: 'double_side' },
                //     ]
                //   }
                // },
                // {
                //   type: 'list',
                //   label: 'Blending',
                //   value: objectUtils<typeof BLENDING_TYPES>({ obj: BLENDING_TYPES, value: material.blending }).key,
                //   key: 'blending',
                //   misc: {
                //     list: [
                //       { label: 'NoBlending', value: THREE.NoBlending, key: 'no_blending' },
                //       { label: 'NormalBlending', value: THREE.NormalBlending, key: 'normal_blending' },
                //       { label: 'AdditiveBlending', value: THREE.AdditiveBlending, key: 'additive_blending' },
                //       { label: 'SubtractiveBlending', value: THREE.SubtractiveBlending, key: 'subtractive_blending' },
                //       { label: 'MultiplyBlending', value: THREE.MultiplyBlending, key: 'multiply_blending' },
                //       { label: 'CustomBlending', value: THREE.CustomBlending, key: 'custom_blending' },
                //     ]
                //   }
                // },
            ]
        }
    }
    return [] as TAssetEditorProp[]
}
export { currentMaterialMesh }
